import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
import { MassBalancerMenu } from './MassBalancerMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { MassBalancerWrapper } from './mass-balancer-modules/mass-balancer-report/massBalanceReportList'
import { MBFM } from './mass-balancer-modules/mass-balancer-report/MassBalFm'
import { WCC2 } from '../data-administration/data-admininstration-list/waste-collector-payment/wCC2'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Mass Balancer',
    path: '/apps/mass-balancer',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const usersBreadcrumbs2: Array<PageLink> = [
  {
    title: 'ISCC',
    path: '/apps/mass-balancer',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const MassBalancerPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<MassBalancerMenu />} />
        <Route
          path='mass-balancer-report'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Mass balance Report</PageTitle>
              <MassBalancerWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='mass-balancer-report2'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Mass balance Report</PageTitle>
              <MBFM />
            </SuspensedView>
          }
        />
        <Route
          path='balance'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Balance</PageTitle>
              <WasteCollectorPaymentList />
            </SuspensedView>
          }
        />
        <Route
          path='pos'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>PoS</PageTitle>
              <WasteCollectorPaymentList />
            </SuspensedView>
          }
        />
        <Route
          path='pos2'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs2}>Sustainability Declaration</PageTitle>
              <WCC2 />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default MassBalancerPage
